import { createSelector } from 'reselect';
import _get from 'lodash/get';
import _head from 'lodash/head';

const getFacets = state => state.facets;

const getProductsAdditionalInfo = state => state.productsAdditionalInfo;

const getBestFilterId = createSelector(
  getFacets,
  getProductsAdditionalInfo,
  (facets, productsAdditionalInfo = {}) => {
    const { nextFacets = {} } = facets;
    const { groupEntities = {} } = nextFacets;
    // this is condition in reducer => item.commonFilter ? "Common" : "Advance";
    // so first item which has common filter false is consider as next best filter only
    // if page is CategoryPage else category is best filter
    const { isCategoryPage } = productsAdditionalInfo;
    // default to category filter
    let bestFilterId = 'l1l3nestedcategory';
    if (isCategoryPage) {
      bestFilterId = '';
      if (groupEntities.Advance && groupEntities.Advance.items) {
        bestFilterId = _head(groupEntities.Advance.items);
      }
    }
    return bestFilterId;
  }
);

const getBestFilterName = createSelector(getFacets, getBestFilterId, (facets, bestFilterId) => {
  const { nextFacets = {} } = facets;
  const { entities = {} } = nextFacets;
  return _get(entities, [bestFilterId, 'name'], '');
});

export { getBestFilterId, getBestFilterName };
